// Mock data for Baitho Conversation Cards

export const productData = {
  id: 'baitho-conversation-cards',
  name: 'Baitho',
  tagline: 'The questions your family has been waiting for you to ask',
  description: '150+ thoughtfully crafted conversation starters designed for Indian families. Transform special moments into extraordinary connections.',
  price: 599,
  originalPrice: 899,
  currency: '₹',
  cardCount: '150+',
  inStock: false,
  preOrder: false,
  waitlist: true,
  limitedQuantity: 100,
  features: [
    '150+ unique conversation prompts',
    'Designed for Indian families',
    'Premium card stock with matte finish',
    'Beautifully illustrated with Indian motifs',
    'Perfect for all ages - 8 to 80',
    'Offline bonding experience'
  ],
  images: {
    logo: 'https://customer-assets.emergentagent.com/job_family-bonds-3/artifacts/97wudht2_IMG_1112.JPG',
    hero: 'https://customer-assets.emergentagent.com/job_family-bonds-3/artifacts/szh6q5l0_IMG_1120.jpeg',
    productBox: 'https://customer-assets.emergentagent.com/job_family-bonds-3/artifacts/qbzktp1m_IMG_1116.jpeg',
    heroAlt: 'https://images.unsplash.com/photo-1704927768400-abefa412fd31',
    familyConversation1: 'https://images.unsplash.com/photo-1704927768407-f1da800e7fb2',
    familyConversation2: 'https://images.unsplash.com/photo-1704927768546-ceaab0de9a4f',
    familyLaughing1: 'https://images.unsplash.com/photo-1683208783648-856f2a6ec12d',
    familyLaughing2: 'https://images.unsplash.com/photo-1597524678053-5e6fef52d8a3',
    listening: 'https://images.unsplash.com/photo-1654588592496-fd32d5d7abc3',
    homeConversation: 'https://images.unsplash.com/photo-1476703993599-0035a21b17a9',
    product: 'https://images.unsplash.com/photo-1613687528267-a5e8dff89f39',
    productTable: 'https://images.pexels.com/photos/4790548/pexels-photo-4790548.jpeg',
    videoThumbnail: 'https://images.unsplash.com/photo-1660807304251-9e2012336d19'
  },
  videoUrl: 'https://www.pexels.com/video/a-family-enjoying-their-time-together-while-having-a-conversation-6894266/'
};

export const sampleQuestions = [
  { 
    id: 1,
    front: 'What is one tradition from our family that you want to continue?',
    back: 'Share why this tradition matters to you and how you would like to keep it alive.',
    category: 'Traditions'
  },
  { 
    id: 2,
    front: 'What is your earliest memory of our home?',
    back: 'Describe the sights, sounds, and feelings of that moment.',
    category: 'Memories'
  },
  { 
    id: 3,
    front: 'If you could ask Dadi or Dada one question, what would it be?',
    back: 'Think about what you have always wondered about their lives.',
    category: 'Generations'
  },
  { 
    id: 4,
    front: 'What does home mean to you?',
    back: 'Is it a place, a feeling, or people?',
    category: 'Belonging'
  },
  { 
    id: 5,
    front: 'Share a time when you felt most proud of our family.',
    back: 'What happened and why did it mean so much?',
    category: 'Pride'
  },
  { 
    id: 6,
    front: 'What is something you learned from a family member that changed you?',
    back: 'How do you carry that lesson with you today?',
    category: 'Lessons'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Meera Patel',
    location: 'Mumbai',
    rating: 5,
    text: 'We use Baitho every Sunday dinner. My teenage son actually looks up from his phone now. These are not just cards—they are conversations we did not know we needed.',
    role: 'Mother of two'
  },
  {
    id: 2,
    name: 'Arjun Reddy',
    location: 'Bangalore',
    rating: 5,
    text: 'I learned more about my father in two rounds of Baitho than I did in 30 years. The questions are beautifully crafted for Indian families.',
    role: 'Son & Entrepreneur'
  },
  {
    id: 3,
    name: 'Kavita Sharma',
    location: 'Delhi',
    rating: 5,
    text: 'Finally, something that bridges the gap between generations. My mother-in-law and I bonded over stories I never knew she had.',
    role: 'Daughter-in-law'
  }
];

export const whoIsThisFor = [
  {
    id: 1,
    title: 'Parents',
    description: 'Who want to really know their kids — beyond homework and screen time',
    icon: '👨‍👩‍👧‍👦'
  },
  {
    id: 2,
    title: 'Kids',
    description: 'Who want to see their parents as people, not just parents',
    icon: '👦👧'
  },
  {
    id: 3,
    title: 'Siblings',
    description: 'Who want to rediscover each other beyond childhood memories',
    icon: '👫'
  },
  {
    id: 4,
    title: 'Extended Families',
    description: 'Tired of small talk at gatherings? Time for real conversations',
    icon: '🏠'
  },
  {
    id: 5,
    title: 'Grandparents',
    description: 'Who have a lifetime of stories waiting to be told',
    icon: '👴👵'
  }
];

export const howItWorks = [
  {
    id: 1,
    title: 'Pick',
    description: 'Anyone picks a card during dinner, chai time, or family gatherings',
    icon: '🎴'
  },
  {
    id: 2,
    title: 'Answer',
    description: 'Take turns sharing stories, thoughts, and memories',
    icon: '💭'
  },
  {
    id: 3,
    title: 'Laugh',
    description: 'Discover surprising stories and bond over shared moments',
    icon: '😄'
  },
  {
    id: 4,
    title: 'Repeat',
    description: 'Make it a tradition—new questions every time',
    icon: '🔄'
  }
];

// Mock cart and orders
let mockCart = [];
let mockOrders = [];

export const cartService = {
  getCart: () => [...mockCart],
  addToCart: (quantity) => {
    const existing = mockCart.find(item => item.productId === productData.id);
    if (existing) {
      existing.quantity += quantity;
    } else {
      mockCart.push({
        id: Date.now().toString(),
        productId: productData.id,
        product: productData,
        quantity: quantity,
        price: productData.price
      });
    }
    return mockCart;
  },
  updateQuantity: (itemId, quantity) => {
    const item = mockCart.find(i => i.id === itemId);
    if (item) {
      item.quantity = quantity;
    }
    return mockCart;
  },
  removeFromCart: (itemId) => {
    mockCart = mockCart.filter(i => i.id !== itemId);
    return mockCart;
  },
  clearCart: () => {
    mockCart = [];
    return mockCart;
  },
  getTotal: () => {
    return mockCart.reduce((total, item) => total + (item.price * item.quantity), 0);
  }
};

export const orderService = {
  createOrder: (orderData) => {
    const order = {
      id: `ORD${Date.now()}`,
      ...orderData,
      items: [...mockCart],
      total: cartService.getTotal(),
      status: 'pending',
      createdAt: new Date().toISOString(),
      paymentMethod: 'mock',
      paymentStatus: 'pending'
    };
    mockOrders.push(order);
    cartService.clearCart();
    return order;
  },
  getOrders: () => [...mockOrders],
  getOrderById: (orderId) => mockOrders.find(o => o.id === orderId),
  updateOrderStatus: (orderId, status) => {
    const order = mockOrders.find(o => o.id === orderId);
    if (order) {
      order.status = status;
      if (status === 'confirmed') {
        order.paymentStatus = 'paid';
      }
    }
    return order;
  }
};
